import axios from 'axios'
import fn from '../../utils/functions'

function initSession () {
  const session = {
    // Plantillas de correo
    mailTemplates: {
      tableData: [],
      totalTemplates: 0
    },
    queryMailTemplates: {
      page: 0,
      size: 20,
      sort: 'mailType,ASC',
      mailType: null,
      language: null,
      project: null,
      userHostServer: null
    },
    listSelectedFiltersMailTemplates: []
  }
  return session
}
function setByUserLocalTemp () {
  const local = {
    // Columnas tabla plantillas de correo
    isShowProjectMailTemplates: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).plantillasdecorreo.isShowProjectMailTemplates,
    isShowLanguageMailTemplates: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).plantillasdecorreo.isShowLanguageMailTemplates,
    isShowMailTypeMailTemplates: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).plantillasdecorreo.isShowMailTypeMailTemplates,
    isShowUserHostServerMailTemplates: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).plantillasdecorreo.isShowUserHostServerMailTemplates,
  }
  return local
}

// state
const state = {
  userConfigLocalStorage: '',
  local: {
    // Columnas tabla plantillas de correo
    isShowProjectMailTemplates: true,
    isShowLanguageMailTemplates: true,
    isShowMailTypeMailTemplates: true,
    isShowUserHostServerMailTemplates: false
  },

  session: initSession()
}

// getters
const getters = {
  queryMailTemplates: state => {
    return state.session.queryMailTemplates
  },
  // Datos Tablas Servicios
  mailTemplates: state => {
    return state.session.mailTemplates
  },
  listSelectedFiltersMailTemplates: state => {
    return state.session.listSelectedFiltersMailTemplates
  },
  // Columnas tabla plantillas de correo
  isShowProjectMailTemplates: state => {
    return state.local.isShowProjectMailTemplates
  },
  isShowLanguageMailTemplates: state => {
    return state.local.isShowLanguageMailTemplates
  },
  isShowMailTypeMailTemplates: state => {
    return state.local.isShowMailTypeMailTemplates
  },
  isShowUserHostServerMailTemplates: state=> {
    return state.local.isShowUserHostServerMailTemplates
  }
}

// actions
const actions = {
  // Crear key Usuario
  setUserNameTemp ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalTemp()
    }
  },

  async isNewVersionPlantillasDeCorreoLocalState ({ state }, localStorage) {
    const isnew = await fn.isNewVersion(state, localStorage.plantillasDeCorreo)
    return isnew
  },
  async getMailTemplates ({
    commit, rootState
  }, data) {
    try {
      data.query.urlName = null
      if (rootState.session.urlIn !== null && rootState.session.urlIn !== undefined &&
          rootState.session.urlIn !== 'b2b') {
        data.query.urlName = rootState.session.urlIn
      }
      const response = await axios({
        method: 'GET',
        url: '/templateMail',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query
      })
      commit('MAILTEMPLATES_STATE', {
        tableData: response.data.content,
        totalTemplates: response.data.totalElements
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)

      return response
    } catch (error) {
      console.log('getMailTemplates: ', error.response)
      throw error.response
    }
  },
  // Detalles plantilla de correo
  async getMailTemplateDetail ({ commit, rootState }, mailTemplateId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/templateMail/' + mailTemplateId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      console.log('RESPONSE getTemplateMail:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error)
      throw error.response
    }
  },
  /* Añade una nueva plantilla a un proyecto */
  async addMailTemplate ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/templateMail/',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          mailType: params.mailType,
          subject: params.subject,
          body: params.body,
          language: params.language,
          project: params.project,
          userHostServer: params.userHostServer
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Elimina una plantilla de correo
  async deleteMailTemplate ({
    commit, rootState
  }, mailTemplateId) {
    try {
      const response = await axios({
        method: 'DELETE',
        url: '/templateMail/' + mailTemplateId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Modifica una plantilla de correo */
  async modifyMailTemplate ({ commit, rootState }, params) {
    try {      
      const response = await axios({
        method: 'PUT',
        url: '/templateMail/' + params.id,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          id: params.id,
          mailType: params.mailType,
          subject: params.subject,
          body: params.body,
          language: params.language,
          project: params.project,
          idUserHostServer: params.userHostServer
        }
      })

      console.log('RESPONSE modifyMailTemplate:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Datos Tabla Plantillas de correo
  mailTemplatesState: ({ commit }, payload) => {
    commit('MAILTEMPLATES_STATE', payload)
  },
  queryMailTemplatesState: ({ commit }, payload) => {
    commit('QUERY_MAILTEMPLATES_STATE', payload)
  },
  listSelectedFiltersMailTemplatesState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_MAILTEMPLATES_STATE', payload)
  },
  // Columnas tabla plantillas de correo
  isShowProjectMailTemplatesAction: ({ commit }, payload) => {
    commit('IS_SHOW_PROJECT_MAILTEMPLATES', payload)
  },
  isShowLanguageMailTemplatesAction: ({ commit }, payload) => {
    commit('IS_SHOW_LANGUAGE_MAILTEMPLATES', payload)
  },
  isShowMailTypeMailTemplatesAction: ({ commit }, payload) => {
    commit('IS_SHOW_NAME_MAILTYPE_MAILTEMPLATES', payload)
  },
  isShowUserHostServerMailTemplatesAction: ({ commit }, payload) => {
    commit('IS_SHOW_USERHOSTSERVER_MAILTEMPLATES', payload)
  }
}

// mutations
const mutations = {
  // Datos Plantillas de correos
  'QUERY_MAILTEMPLATES_STATE' (state, payload) {
    state.session.queryMailTemplates = payload
  },
  'MAILTEMPLATES_STATE' (state, payload) {
    state.session.mailTemplates = payload
  },
  'LIST_SELECTED_FILTERS_MAILTEMPLATES_STATE' (state, payload) {
    state.session.listSelectedFiltersMailTemplates = payload
  },
  // Columnas tabla plantillas de correo
  'IS_SHOW_PROJECT_MAILTEMPLATES' (state, payload) {
    state.local.isShowProjectMailTemplates = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.plantillasdecorreo.isShowProjectMailTemplates = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_LANGUAGE_MAILTEMPLATES' (state, payload) {
    state.local.isShowLanguageMailTemplates = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.plantillasdecorreo.isShowLanguageMailTemplates = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_NAME_MAILTYPE_MAILTEMPLATES' (state, payload) {
    state.local.isShowMailTypeMailTemplates = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.plantillasdecorreo.isShowMailTypeMailTemplates = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_USERHOSTSERVER_MAILTEMPLATES'(state, payload) {
    state.local.isShowUserHostServerMailTemplates= payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.plantillasdecorreo.isShowUserHostServerMailTemplates = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
